// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSubscribe.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import SubscriptionGrid from 'modules/Subscription/Izenda.SubscriptionGrid';
import DashboardSubscriptionConstants from 'logic/data/Izenda.DashboardSubscriptionConstants';
import DashboardSchedulingConstants from 'logic/data/Izenda.DashboardSchedulingConstants';
import { isNil, filter } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';

@connect()
export default class DashboardSubscribe extends Component {
  static propTypes = {
    store: React.PropTypes.object
  };

  constructor(props) {
    super(props);
    const {
      store,
      store: {
        model: {
          dashboardDesignerMode: { isSubscribe }
        }
      },
      isDashboardMode,
      id
    } = props;

    store.initSubscription();
    this.pageConstants = isSubscribe ? DashboardSubscriptionConstants : DashboardSchedulingConstants;
    //Get dashboard detail with common filter here
    isDashboardMode && store.updateCommonFilter(id);
  }

  componentDidMount() {
    const {
      store,
      store: { subscribedInstancesStore },
      store: {
        model: { dashboardDetail }
      },
      store: {
        model: {
          dashboardDetail: { dashboard }
        }
      },
      store: {
        model: {
          dashboardDetail: {
            dashboard: { subscriptions }
          }
        }
      },
      store: {
        model: {
          dashboardDesignerMode: { isSubscribe }
        }
      },
      id
    } = this.props;

    const dashboardId = id || dashboard.id;
    !isNil(dashboardId) &&
      dashboardId !== subscribedInstancesStore.dashboardId &&
      subscribedInstancesStore.updateDashboardId(dashboardId, isSubscribe);

    if (isNil(dashboardId)) {
      const instances = filter(item => item.isSubscription === isSubscribe, subscriptions.toJS());
      subscribedInstancesStore.loadInstances(instances);
    } else {
      subscribedInstancesStore.loadInstances(isSubscribe);
      if (dashboardDetail.dashboard.id) dashboardDetail.cleanDirty();
    }
  }

  componentWillUnmount() {
    this.props.store.subscribedInstancesStore.disposeObserveSubscriptions();
    this.props.store.dashboardDesignerMode.resetAlertDetails();
  }

  /**
   * Save subscription data.
   */
  onSaveSubscription = (subData: any) => {
    const {
      store: {
        subscribedInstancesStore: { model }
      },
      doesSaveToDB
    } = this.props;

    //Update for dashboard grid
    model.updateSubscribedInstances(subData);
    //Update to dashboard detail
    this.syncSubscriptions(model.subscribedInstances);
    // doesSaveToDB &&
    this.onDashboardModeSave();
  };

  /**
   * Save subscription data.
   */
  syncSubscriptions = (instances: Array<any>) => {
    const {
      store: {
        model: {
          dashboardDesignerMode: { isSubscribe }
        }
      },
      store: {
        model: { dashboardDetail }
      }
    } = this.props;
    dashboardDetail.syncSubscriptions(instances, isSubscribe);
  };

  /**
   * Save subscribed instances
   * This is used for save subscribed instances in dashboard list.
   */
  onDashboardModeSave = () => {
    const {
      store,
      store: { subscribedInstancesStore },
      store: {
        subscribedInstancesStore: { model }
      },
      store: {
        model: {
          dashboardDesignerMode: { isSubscribe },
          dashboardDetail
        }
      },
      id,
      loader
    } = this.props;

    const isDirty = model.checkDirty();

    store.dashboardDesignerMode.resetAlertDetails();

    if (isDirty) {
      loader.startLoading();
      const savingInstances = model.buildDataForSaving();
      return store
        .saveDashboardSubscriptions(id, savingInstances)
        .then(result => 
          result.success ? (
          subscribedInstancesStore.loadInstances(isSubscribe),
            // set Alert messages
          store.dashboardDesignerMode.setAlertDetails({
            success: true,
            message: localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          }))
          : Promise.resolve(result)
      )
        .then(result => {
          if (dashboardDetail.dashboard.id) dashboardDetail.cleanDirty();
          return result;
        })
        .finally(loader.endLoading.bind(loader)
        );
    }
  };

  updateCascadingFilterValue = (
    sourceFilter: any,
    configFieldList: Array<any>,
    subscriptionCommonFilterFields: Array<any>
  ) => {
    this.props.store.dashboardFilterStore.updateCascadingFilterValue(
      sourceFilter,
      configFieldList,
      subscriptionCommonFilterFields
    );
  };

  render() {
    const {
      store: { subscribedInstancesStore },
      store: {
        model: { dashboardDetail }
      },
      width,
      isDashboardMode,
      onClose,
      doesSaveToDB
    } = this.props;

    return (
      <SubscriptionGrid
        updateCascadingFilterValue={this.updateCascadingFilterValue}
        store={subscribedInstancesStore}
        pageConstants={this.pageConstants}
        containerWidth={width}
        isPopupMode={false}
        isDashboardMode={isDashboardMode}
        onClose={onClose}
        onSave={this.onDashboardModeSave}
        onSavePopupDesigner={this.onSaveSubscription}
        onSyncSubscription={this.syncSubscriptions}
        doesSaveToDB={doesSaveToDB}
        dashboardDetail={dashboardDetail}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardSubscribe/Izenda.DashboardSubscribe.js